/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import EmptyView from "../../EmptyView";
import PluginCardSkeleton from "../../skeleton/PluginCardSkeleton";
import PackageItem from "./PackageItem";
import styled from "styled-components";
import Icon from "../../ui/Icon";
import Stack from "../../ui/Stack";
import SearchSortBar from "../SearchSortBar";

const PackageItemSkeletons = styled(Stack)`
  grid-template-columns: repeat(auto-fill, minmax(min(314px, 100%), 1fr));

`;

const StyledInnerWrapper = styled(Stack)`
  grid-template-columns: repeat(auto-fill, minmax(min(314px, 100%), 1fr));
`;

const PackagesList = ({
  packages, isLoading, selectedPackages = [], onSelect, onDateChange, readOnly,
  searchValue, sortBy, onSearchChange, onSortChange,
  filterGroups = [], selectedFilters = [], onFilterChange, onClearFilters,
}) => {
  return (
    <>
      <SearchSortBar
        searchValue={searchValue}
        sortBy={sortBy}
        onSearchChange={onSearchChange}
        onSortChange={onSortChange}
        filterGroups={filterGroups}
        selectedFilters={selectedFilters}
        onFilterChange={onFilterChange}
        onClearFilters={onClearFilters}
      />

      {isLoading && (
        <PackageItemSkeletons $gap="0.5rem">
          <PluginCardSkeleton withIncludes />
        </PackageItemSkeletons>
      )}

      {!isLoading && !packages?.length && (
        <EmptyView icon={Icon.BoxArchive} description="No packages available" />
      )}

      {!isLoading && packages?.length > 0 && (
        <StyledInnerWrapper $gap="0.5rem">
          {packages.map((pkg) => (
            <PackageItem
              key={pkg.id}
              pkg={pkg}
              readOnly={readOnly}
              isSelected={selectedPackages.some((item) => item.params?.package_id === pkg.id)}
              initialDate={selectedPackages.find((item) => item.params?.package_id === pkg.id)?.params?.start_date}
              onSelect={onSelect}
              onDateChange={onDateChange}
            />
          ))}
        </StyledInnerWrapper>
      )}
    </>
  );
};

export default PackagesList;